import { faker } from "@faker-js/faker";
import type { Meta, StoryObj } from "@storybook/react";

import type { BaseDocumentCardProps } from "@/ui/core/BaseDocumentCard";
import BaseDocumentCard from "@/ui/core/BaseDocumentCard";

const StoryMeta: Meta<BaseDocumentCardProps> = {
  title: "Core/Base Document Card",
  component: BaseDocumentCard,
  argTypes: {
    description: { control: { type: "text" } },
    fileDisplayName: { control: { type: "text" } },
    fileName: { control: { type: "text" } },
    id: { control: { type: "text" } },
    isInvalid: { control: { type: "boolean" } },
    isLoading: { control: { type: "boolean" } },
    isShareable: { control: { type: "boolean" } },
    onPress: { action: "pressed" },
    onSharePress: { action: "share" },
  },
  args: {
    fileName: "file.pdf",
    id: faker.string.uuid(),
  },
};

type Story = StoryObj<BaseDocumentCardProps>;

const Primary: Story = {};

const Shareable: Story = {
  args: {
    isShareable: true,
  },
};

const Loading: Story = {
  args: {
    isLoading: true,
  },
};
const WithDescription: Story = {
  args: {
    description: "Sent by you",
  },
};

const WithDocumentDisplayName: Story = {
  args: {
    fileDisplayName: "Clinical Note",
    fileName: "file.docx",
  },
};

const WithWordDocument: Story = {
  args: {
    fileName: "file.docx",
  },
};
const WithExcelDocument: Story = {
  args: {
    fileName: "file.xlsx",
  },
};
const WithInvalidFile: Story = {
  args: {
    isInvalid: true,
  },
};

export default StoryMeta;
export {
  Loading,
  Primary,
  Shareable,
  WithDescription,
  WithDocumentDisplayName,
  WithExcelDocument,
  WithInvalidFile,
  WithWordDocument,
};
